import { FlexBox } from 'src/ui/common/atoms/flex-box';
import { Grid } from 'src/ui/common/atoms/grid';
import { media } from 'src/ui/common/mixins/media';
import styled, { css } from 'styled-components';

export const StyledCheckoutWrapper = styled(Grid)`
    padding: 0;

    ${media.md(css`
        padding: 16px 0;
    `)}
`;

export const StyledLeftColumn = styled.div`
    width: 100%;
    padding: 16px 0;

    ${media.md(css`
        min-width: 660px;
    `)}
`;

export const StyledCheckoutTitle = styled.div`
  font-size: 28px;
  font-family: ${({ theme }) => theme.fonts.title}
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text};
  margin-bottom: 12px;
`;

export const StyledFormWrapper = styled.div<{ mode?: 'form' | 'edit'; stepper?: boolean }>`
    padding: 24px 0;

    ${media.md`
        background-image: ${({ stepper }: { stepper: boolean }) =>
            stepper ? 'linear-gradient(#1D201F 33%, #858A88 0%)' : 'none'};
        background-position: left;
        background-size: 1px 8px;
        background-repeat: repeat-y;
        margin-left: ${({ stepper }: { stepper: boolean }) => (stepper ? '22px' : '0')};
        padding: ${({ stepper }: { stepper: boolean }) => (stepper ? '24px 22px' : '0 0 10px 0')};
    `}
`;

export const StyledButtonWrapper = styled.div<{ mode?: 'form' | 'edit'; stepper?: boolean }>`
    margin-top: -40px;
    padding: 24px 0;

    ${media.md`
        background-image: ${({ stepper }: { stepper: boolean }) =>
            stepper ? 'linear-gradient(white 33%, #25c2bd 0%)' : 'none'};
        background-position: left;
        background-size: 1px 8px;
        background-repeat: repeat-y;
        margin-left: ${({ stepper }: { stepper: boolean }) => (stepper ? '22px' : '0')};
        padding: ${({ stepper }: { stepper: boolean }) => (stepper ? '24px 22px' : '24px 0')};
    `}
`;

export const StyledInputWrapper = styled(FlexBox)`
    margin-bottom: 16px;
    flex: 1 1 auto;

    & > div {
        margin-bottom: 5px;
        font-size: 14px;
        color: ${({ theme }) => theme.colors.text};
    }
`;

export const StyledReviewWrapper = styled.div`
    font-size: 14px;
    color: ${({ theme }) => theme.colors.grey600};
    padding: 24px 0;
`;

export const StyledOrderSummaryWrapper = styled.div``;

export const StyledSummaryTitle = styled.div`
    font-family: ${({ theme }) => theme.fonts.title};
    color: ${({ theme }) => theme.colors.white};
    font-size: 20px;
    line-height: 140%;
    padding: 0 0 15px 0;

    & > span {
        font-weight: 400;
        color: ${({ theme }) => theme.colors.gs100};
        font-size: 20px;
    }
`;

export const StyledOrderItem = styled(FlexBox)`
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    gap: 12px;
    padding: 15px;

    & img {
        max-width: 72px;
        box-shadow: 0 4px 100px 0 rgba(0, 0, 0, 0.05);
        border-radius: 8px;
    }
`;

export const StyledArtLabel = styled(FlexBox)`
    padding: 5px 12px;
    gap: 5px;
    align-items: center;
    font-size: 12px;
    border-radius: 12px;
    letter-spacing: 0.01px;
    color: ${({ theme }) => theme.colors.cyan700};
    background: ${({ theme }) => theme.colors.lightGreen};
`;

export const StyledSumWrapper = styled(FlexBox)`
    margin-top: 5px;
    border-top: 1px solid rgba(255, 255, 255, 0.06);
    padding: 15px 0;
    gap: 8px;
`;

export const StyledTotalAmountWrapper = styled.div`
    padding: 15px 0;
    border-top: 1px solid rgba(255, 255, 255, 0.06);
`;

export const StyledTotalNum = styled.span`
    font-size: 20px;
    color: white;
`;

export const StyledFilesDownloaderWrapper = styled.div`
    padding: 15px 0;
    border-top: 1px solid rgba(255, 255, 255, 0.06);

    & span.count {
        color: ${({ theme }) => theme.colors.gs100};
        font-weight: 400;
        font-size: 14px;
    }
`;

export const StyledFileWrapper = styled(FlexBox)`
    gap: 12px;
    margin-bottom: 10px;
`;

export const StyledArtTypeWrapper = styled(FlexBox)`
    width: 40px;
    height: 40px;
    border-radius: 6px;
    background: ${({ theme }) => theme.colors.grey900};
    color: ${({ theme }) => theme.colors.gs100};
    font-size: 12px;
`;

export const StyledSecureCheckout = styled(FlexBox)`
    color: ${({ theme }) => theme.colors.gs100};
    text-decoration: underline;
    border-top: 1px solid rgba(255, 255, 255, 0.06);
    padding-top: 15px;

    & svg {
        color: ${({ theme }) => theme.colors.gs100};
    }
`;
